import React, { useState } from 'react';
import { toastService } from '../../../../services/toast.service';

interface IProps {
	endpointId: string;
	secret: string;
	onRoll: (id: string) => Promise<{ secret: string } | undefined>;
}

const WebhookSecret = ({ endpointId, secret, onRoll }: IProps) => {
	const [shown, setShown] = useState(false);
	const [rolling, setRolling] = useState(false);
	// The list refetches after a roll, but show the fresh value at once.
	const [rolled, setRolled] = useState<string | null>(null);
	const value = rolled ?? secret;

	const copy = async () => {
		try {
			await navigator.clipboard.writeText(value);
			toastService.success('Webhook secret copied to clipboard');
		} catch {
			toastService.error('Could not copy.');
		}
	};

	const roll = async () => {
		if (!window.confirm('Roll the signing secret? The old secret keeps signing for 24 hours.')) return;
		setRolling(true);
		const res = await onRoll(endpointId);
		setRolling(false);
		if (!res) return;
		setRolled(res.secret);
		setShown(true);
		toastService.success('Secret rolled');
	};

	return (
		<div className="form-group">
			<label><strong>Signing secret</strong></label>
			<div className="input-group">
				<input type="text" className="form-control" readOnly value={shown ? value : '•'.repeat(24)} />
				<div className="input-group-append">
					<button type="button" className="btn btn-outline-secondary" onClick={() => setShown((s) => !s)}>{shown ? 'Hide' : 'Reveal'}</button>
					<button type="button" className="btn btn-outline-secondary" onClick={copy}>Copy</button>
					<button type="button" className="btn btn-outline-danger" onClick={roll} disabled={rolling}>{rolling ? 'Rolling...' : 'Roll'}</button>
				</div>
			</div>
		</div>
	);
};

export default WebhookSecret;
